import { __extends, __rest } from "tslib";
import React, { Component } from "react";
import { View } from "react-native";
import PropTypes from "prop-types";
import styles from "./PnmacTable.styles.js";
var PnmacTable = /** @class */function (_super) {
  __extends(PnmacTable, _super);
  function PnmacTable() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  PnmacTable.prototype._renderChildren = function (props) {
    return React.Children.map(props.children, function (child) {
      return /*#__PURE__*/React.cloneElement(child, props.borderStyle && child.type.displayName !== "ScrollView" ? {
        borderStyle: props.borderStyle
      } : {});
    });
  };
  PnmacTable.prototype.render = function () {
    var _a = this.props,
      borderStyle = _a.borderStyle,
      rest = __rest(_a, ["borderStyle"]);
    var borderLeftWidth = borderStyle && borderStyle.borderWidth || 0;
    var borderBottomWidth = borderLeftWidth;
    var borderColor = borderStyle && borderStyle.borderColor || "#000";
    return /*#__PURE__*/React.createElement(View, {
      style: [this.props.style, {
        borderLeftWidth: borderLeftWidth,
        borderBottomWidth: borderBottomWidth,
        borderColor: borderColor
      }],
      nativeID: rest.idTag1
    }, this._renderChildren(this.props));
  };
  return PnmacTable;
}(Component);
PnmacTable.propTypes = {
  style: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array]),
  borderStyle: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array])
};
export default PnmacTable;